import './external/global.js';
import './main/app.js';